import styled, { css } from 'styled-components';


export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    gap: 24px;
  `}
`;

export const SelectPaymentLabel = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm2};
    margin: 0;
  `};
`;

export const PaymentMethodsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const RadioLabel = styled.div``;

export const MobileDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`;

export const InfosLoadingContainer = styled.div`
  display: flex;
  gap: 24px;
`;
